<template>
  <b-card>
    <!-- about -->
    <b-card-text>
      <h3><feather-icon icon="HelpCircleIcon" size="22" /> إرشادات</h3>
      <hr />
      <!-- <div v-if="docs.content" v-html="docs.content"></div> -->
      <p>هذه الصفحات تظهر عند انتظار الموافقة على طلب التأسيس من قبل الوزارة</p>
    </b-card-text>
  </b-card>
</template>
<!-- TODO : DOCS intergration -->
<script>
import { BCard, BCardText } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    BCard,
    BCardText,
  },
  computed: {
    ...mapGetters("NgoProfile", ["docs"]),
  },
  methods: {
    ...mapActions("NgoProfile", ["fetchDocs"]),
  },
  mounted() {
    // if (this.$route.meta.slug) this.fetchDocs(this.$route.meta.slug);
  },
  watch: {
    "$route.meta.slug"(val) {
      // if (val) this.fetchDocs(val);
    },
  },
};
</script>
